import { Truck, Ship } from "lucide-react";
import { Reveal } from "./Reveal";

const MAINLAND = [
  "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna", "Friuli-Venezia Giulia",
  "Lazio", "Liguria", "Lombardia", "Marche", "Molise", "Piemonte", "Puglia",
  "Toscana", "Trentino-Alto Adige", "Umbria", "Valle d'Aosta", "Veneto",
];
const ISLANDS = ["Sicilia", "Sardegna"];

const Stat = ({ icon: Icon, time, label, dark, testid }) => (
  <div data-testid={testid} className={`rounded-3xl p-7 sm:p-10 flex flex-col justify-between gap-10 ${dark ? "bg-[#1A110C] text-[#FDFBF7]" : "bg-[#E8893F] text-[#1A110C]"}`}>
    <Icon className="w-8 h-8" />
    <div>
      <p className="font-serif text-6xl sm:text-7xl leading-none tracking-tight">{time}</p>
      <p className="mt-3 text-xs uppercase tracking-[0.2em] font-semibold">{label}</p>
    </div>
  </div>
);

export const Delivery = () => (
  <section id="consegna" data-testid="delivery-section" className="bg-[#FDFBF7] text-[#2A1C15] pb-24 sm:pb-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 border-t border-[#2A1C15]/15 pt-20 sm:pt-28">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <p className="text-xs uppercase tracking-[0.3em] text-[#8C4A28] mb-5">Zone di consegna</p>
          <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] tracking-tight">
            In tutta <em className="text-[#C9692C]">Italia.</em>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-[#2A1C15]/75 leading-relaxed">
            Consegna e spedizione online del pellet in vero legno di abete in ogni regione: 24/48h nella penisola, 5/6 giorni per Sicilia e Sardegna.
          </p>
        </Reveal>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          <Reveal><Stat icon={Truck} time="24/48h" label="Italia peninsulare" dark testid="delivery-mainland" /></Reveal>
          <Reveal delay={0.1}><Stat icon={Ship} time="5/6 gg" label="Sicilia e Sardegna" testid="delivery-islands" /></Reveal>
        </div>
      </div>

      <Reveal delay={0.1} className="mt-14">
        <ul data-testid="delivery-regions" className="flex flex-wrap gap-2.5">
          {MAINLAND.map((r) => (
            <li key={r} className="rounded-full border border-[#2A1C15]/20 px-4 py-2 text-sm hover:bg-[#1A110C] hover:text-[#FDFBF7] transition-colors">
              {r} <span className="text-[#8C4A28] font-semibold">· 24/48h</span>
            </li>
          ))}
          {ISLANDS.map((r) => (
            <li key={r} className="rounded-full bg-[#E8893F]/15 border border-[#E8893F] px-4 py-2 text-sm hover:bg-[#E8893F] transition-colors">
              {r} <span className="text-[#8C4A28] font-semibold">· 5/6 giorni</span>
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
